/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* Premium serum homepage: transparent-safe header behavior */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-index')) return;
  document.documentElement.classList.add('SerumHomeEnabled');
});

/* Cart drawer: add the Bloom ritual without nesting a second form. */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-bloom-upsell-add]');
  if (!button || button.disabled) return;

  button.disabled = true;
  var originalLabel = button.textContent;
  button.textContent = 'Ajout en cours…';

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(button.getAttribute('data-variant-id')), quantity: 1 })
  }).then(function (response) {
    if (!response.ok) throw new Error('add_failed');
    window.location.reload();
  }).catch(function () {
    button.disabled = false;
    button.textContent = originalLabel;
  });
});
